import { formatNumber } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { TableLightColumnComponent } from "./table-light-column/table-light-column.component";

@Component({
    standalone: false,
    selector: "app-table-light",
    templateUrl: "./table-light.component.html",
    styleUrls: ["./table-light.component.css"],
})
export class TableLightComponent extends FieldType<FieldTypeConfig> implements OnInit {
    @Input() data: object[] = [];
    @Input() showFooter: boolean = false;

    @Output() onRowChanged: EventEmitter<any> = new EventEmitter<any>();

    columns: TableLightColumnComponent[] = [];

    addColumn(column: TableLightColumnComponent) {
        column.onRowChanged = this.onRowChanged;

        this.columns.push(column);
    }

    buildContext(
        row: object,
        column: TableLightColumnComponent,
        rowIndex: number
    ) {
        return {
            row: row,
            column: column,
            rowIndex: rowIndex,
            rowCount: this.data.length,
        };
    }

    trackChanges = (index: number, row: object) => row;

    ngOnInit(): void {
        this.data = this.data || [];
    }

    getVisibleColumnsLength(): number {
        return this.columns.filter((x) => x.visible !== false).length;
    }

    getTotalWidth(): number {
        var columns = this.columns.filter((x) => x.visible !== false);
        var totalWidth = 0;

        columns.forEach((x) => (totalWidth += x.width));

        return totalWidth;
    }

    getFooterContent(column: TableLightColumnComponent): string {
        if (!column.totalInFooter) return "";

        var value = 0;

        let data = this.data || [];

        data.forEach((x) => {
            let temp = x[column.value];
            if (!isNaN(temp)) value += +temp;
        });

        return formatNumber(value, "en-us", "1.2-2");
    }

    isColumnFrozen(column: TableLightColumnComponent): boolean {
        let isMobileSize = window.innerWidth <= 768;

        if (!column.frozen || (isMobileSize && column.unfrozenOnMobile == true))
            return false;

        return true;
    }

    getLeftBuffer(column: TableLightColumnComponent, index: number): string {
        if (!this.isColumnFrozen(column)) return null;

        var frozenSize = 0;

        for (var i = 0; i < index; i++) {
            var currentColumn = this.columns[i];
            if (currentColumn.frozen && currentColumn.visible != false) {
                let minWidth: string = this.getMinWidth(currentColumn);
                if (minWidth) {
                    minWidth = minWidth.substr(0, minWidth.length - 2);
                    frozenSize += +minWidth;
                }
            }
        }

        column.leftBuffer = frozenSize + "px";

        return column.leftBuffer;
    }

    getMinWidth(column: TableLightColumnComponent): string {
        return this.calculateWidth(column) || "200px";
    }

    calculateWidth(column: TableLightColumnComponent): string {
        if (column.width) return column.width + "px";

        switch ("" + column.type) {
            case "number":
                return "100px";
            case "options":
                return "50px";
            default:
                return "200px";
        }
    }
}
